import * as constants from '@/store/modules/activityFilters/activity-filters-types';

export default {
  [constants.APPLY_FILTERS] (state, filters) {
    console.log('state', state, filters)
    state.filters = [...filters]
  },
}
